<!--
 * @Description: Description
 * @Author: 艾欢欢
 * @Date: 2020-12-21 15:39:11
 * @LastEditTime: 2021-08-21 21:33:20
 * @LastEditors: zhangcx33595
 * @FilePath: \openplat-web\src\gtn\components\dialog\LoginModal.vue
-->
<template>
  <!-- <div class="dialog-box bg" v-if="showDialog" :style="{dispaly: !showDialog && 'none'}"> -->
  <div class="dialog-box bg" v-if="showDialog">
    <div class="pos-center" @click.stop>
      <h-icon name="close" class="close-btn" @click.native="closer"></h-icon>
      <LoginMethods :isLoginModal="showModal" :showBind="showBind" />
    </div>
  </div>
</template>

<script>
import LoginMethods from "@/views/frontViews/components/loginMethods"
export default {
  name: 'Dialog',
  components: { LoginMethods },
  watch: {
    $route () {
      this.closer()
    }
  },
  data () {
    return {
      showModal: true,
      showDialog: true,
      showBind: false,
    }
  },
  created () {
    localStorage.setItem('showBindModal', false)
  },
  methods: {
    closer () {
      this.showDialog = false
      this.initPage()
    },
    initPage () {
      localStorage.setItem('showBindModal', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 110;
}
.bg {
  background: rgba($color: #333333, $alpha: 0.5);
}
.pos-center {
  position: absolute;
  top: 50%;
  left: calc(50% + 24px);
  transform: translate(-50%, -50%);
}

.close-btn {
  float: right;
  font-size: 24px;
  color: #ccc;
  margin-left: 12px;
  margin-top: -10px;
  cursor: pointer;
  &:hover {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/components/dialog/LoginModal.vue